import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ImageIcon from "@material-ui/icons/Image";
import VideocamIcon from "@material-ui/icons/Videocam";
import DescriptionIcon from "@material-ui/icons/Description";

import { substituteVars } from "./helpers";
import WabaTemplateButtons from "./WabaTemplateButtons";

// Preview fiel de una plantilla HSM: reproduce la burbuja saliente de WhatsApp
// (header media/text, body con variables resueltas, footer y botones). Doc 0367 (H7).
const useStyles = makeStyles((theme) => ({
  wrapper: {
    background: "#e5ddd5",
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Ccircle cx='2' cy='2' r='1' fill='%23d0c8bd'/%3E%3C/svg%3E\")",
    padding: theme.spacing(2),
    borderRadius: 6,
    display: "flex",
    justifyContent: "flex-end",
    minHeight: 120,
  },
  bubble: {
    background: "#dcf8c6",
    borderRadius: 8,
    padding: theme.spacing(1),
    maxWidth: "85%",
    boxShadow: "0 1px 0.5px rgba(0,0,0,0.13)",
    position: "relative",
    fontSize: "0.875rem",
    color: "#111",
  },
  headerText: { fontWeight: 700, marginBottom: 4, whiteSpace: "pre-wrap", wordBreak: "break-word" },
  headerMedia: {
    background: "#c9e6b8",
    borderRadius: 6,
    height: 120,
    marginBottom: 6,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#4a7a3a",
    overflow: "hidden",
  },
  headerImg: { width: "100%", height: "100%", objectFit: "cover" },
  body: { whiteSpace: "pre-wrap", wordBreak: "break-word", lineHeight: 1.4 },
  footer: { color: "#667781", fontSize: "0.75rem", marginTop: 6, whiteSpace: "pre-wrap" },
  time: { fontSize: "0.6875rem", color: "#667781", textAlign: "right", marginTop: 2 },
}));

const MediaPlaceholder = ({ format, url, classes }) => {
  if (format === "IMAGE" && url) {
    return <img src={url} alt="header" className={classes.headerImg} onError={(e) => { e.target.style.display = "none"; }} />;
  }
  const Icon = format === "VIDEO" ? VideocamIcon : format === "DOCUMENT" ? DescriptionIcon : ImageIcon;
  return (
    <>
      <Icon style={{ fontSize: 40 }} />
      <span style={{ fontSize: "0.75rem", marginTop: 4 }}>
        {format === "VIDEO" ? "Video" : format === "DOCUMENT" ? "Documento" : "Imagen"}
      </span>
    </>
  );
};

export default function WabaTemplatePreview({ parsed, headerMediaUrl, headerTextVars = [], bodyVars = [] }) {
  const classes = useStyles();
  if (!parsed) return null;

  const { header, body, footer, buttons } = parsed;
  const bodyText = substituteVars(body?.text, bodyVars);
  const headerText = header && !header.isMedia ? substituteVars(header.text, headerTextVars) : "";

  return (
    <div className={classes.wrapper}>
      <div className={classes.bubble}>
        {header?.isMedia && (
          <div className={classes.headerMedia}>
            <MediaPlaceholder format={header.format} url={headerMediaUrl} classes={classes} />
          </div>
        )}
        {header && !header.isMedia && headerText && (
          <div className={classes.headerText}>{headerText}</div>
        )}

        {bodyText && <div className={classes.body}>{bodyText}</div>}

        {footer?.text && <div className={classes.footer}>{footer.text}</div>}

        <div className={classes.time}>12:00</div>

        <WabaTemplateButtons buttons={buttons} />
      </div>
    </div>
  );
}
